<template>
  <div class="container">
    <div class="row justify-content-md-center">
      <div class="col col-lg-8">
        <br>
        <item-detail :id="$route.params.id"></item-detail>
        <br>
        <p class="text-center">
          <router-link to="/users"><i class="fa fa-angle-double-left"></i> Return to list</router-link>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import ItemDetail from "@/components/user/_Detail";

export default {
  name: "user-show",
  components: {
    ItemDetail
  }
};
</script>
